export const MAX_FILTERS_NUMBER = 5
